import getOr from "lodash/fp/getOr";
import { responseForm } from "../../components/walkthrough";

import { apiContact, apiSendToEmail } from "../../utils/api";
import { getCurrentUser } from "../../utils/firebase";
import { getPrice, validate, validateEmail } from "../../utils/utils";
import { search } from "./searchBar";
import { initTrackHelpToYou } from "../../utils/track";

const $ = window.jQuery;
const helptoyou = require('../../models/helptoyou.json');

export const initEventLanding = () => {
  window.sliderHelpLength = Object.keys(helptoyou).length;

  $(".contact-form .btn").on("click", function (e) {
    const apiTime = Date.now();
    window.apiTime = apiTime;
    if (validateContact()) {
      submitData(apiTime);
    }
  });

  $(".sendMeEmail-form").on("submit", function (e) {
    e.preventDefault();
    const apiTime = Date.now();
    window.apiTime = apiTime;
    if (validateSendMeEmail()) {
      if ($('.walkthrough.open').length > 0) {
        search(false, true, true);
      }
      submitDataSendMeEmail(apiTime);
    }
  });

  $('.name input').on('keyup', function (e) {
    if (e.keyCode !== 13) {
      validate('.name input', undefined, true);
    }
  });

  $('.email input').on('keyup', function (e) {
    if (e.keyCode !== 13) {
      validate(".email input", undefined, true);
    }
  });

  $(".section-requirement .box").on("click", function (e) {
    try {
      if (window.getSelection().getRangeAt(0).startOffset === window.getSelection().getRangeAt(0).endOffset && e.target.tagName !== "BUTTON" && window.outerWidth >= 992) {
        $($(this).attr("data-target")).collapse("toggle");
      }
    } catch (error) {
      console.error(error);
    }
  });

  $(window).scroll(function () {
    if ($('.help1').length > 0 && $(this).scrollTop() >= $('.help1')[0].offsetTop - 400) {
      $('.help1').addClass("active");
    }
    if ($('.help2').length > 0 && $(this).scrollTop() >= $('.help2')[0].offsetTop - 400) {
      $('.help2').addClass("active");
    }
    if ($('.help3').length > 0 && $(this).scrollTop() >= $('.help3')[0].offsetTop - 400) {
      $('.help3').addClass("active");
    }
    if ($('.section-landing .row-eq-height').length > 0 && $(this).scrollTop() >= $('.section-landing .row-eq-height')[0].offsetTop - 400) {
      $('.section-landing .row-eq-height').addClass("active");
    }
  });

  $('.section-landing .row-eq-height').on('click', function (e) {
    var index = window.currentIndex !== undefined ? (window.currentIndex < window.sliderHelpLength - 1 ? parseInt(window.currentIndex) + 1 : 0) : 0;
    $(`.navigation-slider .number-slider .number`).removeClass("active");
    $(`.navigation-slider .number-slider .number#${index}`).addClass("active");
    setClassSlider(index);
    window.currentIndex = index;
  });

  $('.section-top .banner .slogan .get-button .btn').on('click', function (e) {
    // $('.section-search .product input.form-control').focus();
    var element = $('.section-search');
    if (element && element[0]) {
      $('html, body').animate({
        scrollTop: element[0].offsetTop
      }, 500);
    }
  });
}

export const initDataLanding = () => {
  var htmlSliderList = ""
  Object.keys(helptoyou).forEach((element, index) => {
    htmlSliderList += `<div class="number ${index === window.currentIndex && "active"}" id="${index}"><span>${index + 1}. ${helptoyou[element].title}</span></div>`;
  });
  $(".navigation-slider .number-slider").html(htmlSliderList);
  $('.navigation-slider .number-slider .number').on('click', function (e) {
    var index = parseInt(e.currentTarget.id);
    if (window.currentIndex !== index) {
      $(`.navigation-slider .number-slider .number`).removeClass("active");
      $(`.navigation-slider .number-slider .number#${index}`).addClass("active");
      setClassSlider(index);
      window.currentIndex = index;
    }
  });
  initTrackHelpToYou();
  setClassSlider(window.currentIndex);
}

function submitData(apiTime) {
  apiContact({
    meta_data: {
      name: $('.contact-form .name input').val(),
      email: $('.contact-form .email input').val(),
      message: $('.contact-form .feedback textarea').val(),
      export_country: $('.export-country select').val(),
      destination_country: $('.destination-country select').val(),
      product: window.searchData.hs || $('.product input.form-control').val(),
      order_value: getPrice($('.order-value input').val()),
      quantity: getPrice($(".order-quantity input").val()),
      currency: $('.order-value select').val()
    }
  }, function (data) {
    $(".contact-form .message").show();
    setTimeout(function () {
      $(".contact-form .message").hide();
    }, 3000);
    resetForm();
  }, function (error) {
    $(".contact-form .message").show();
    resetForm();
  }, apiTime);
}

function validateContact() {
  return validate(".contact-form .name input") && validate(".contact-form .email input", validateEmail);
}

function validateSendMeEmail() {
  return validate(".sendMeEmail-form .name input") && validate(".sendMeEmail-form .email input", validateEmail);
}

function resetForm() {
  const user = getCurrentUser();
  const displayName = getOr("", "displayName")(user);
  const email = getOr("", "email")(user);
  $('.contact-form .name input').val(displayName).trigger("change");
  $('.contact-form .email input').val(email).trigger("change");
  $('.contact-form .feedback textarea').val("").trigger("change");
}

function submitDataSendMeEmail(apiTime) {
  apiSendToEmail({
    url: window.location.href,
    email: $('.sendMeEmail-form .email input').val(),
    name: $('.sendMeEmail-form .name input').val(),
    meta_data: {
      name: $('.sendMeEmail-form .name input').val(),
      email: $('.sendMeEmail-form .email input').val(),
      url: window.location.href,
      export_country: $('.export-country select').val(),
      destination_country: $('.destination-country select').val(),
      product: window.searchData.hs || $('.product input.form-control').val(),
      order_value: getPrice($('.order-value input').val()),
      quantity: getPrice($(".order-quantity input").val()),
      currency: $('.order-value select').val()
    }
  }, function (data) {
    $(".sendMeEmail-form .message").show();
    setTimeout(function () {
      $(".sendMeEmail-form .message").hide();
    }, 5000);
    resetFormSendMeEmail();
    responseForm(search);
  }, function (error) {
    $(".sendMeEmail-form .message").show();
    resetFormSendMeEmail();
    responseForm(search);
  }, apiTime);
}

function resetFormSendMeEmail() {
  $('.sendMeEmail-form .name input').val("").trigger("change");
  $('.sendMeEmail-form .email input').val("").trigger("change");
}

export function setClassSlider(index) {
  $(`.section.section-landing .row-eq-height`).empty();
  genHtmlHelpToYou(helptoyou[`slider_${window.currentIndex}`], window.sliderHelpLength);
  genHtmlHelpToYou(helptoyou[`slider_${index}`], window.sliderHelpLength - 1);
  var cur = 1;
  var j = index;
  var classIndex = window.sliderHelpLength - 2;
  while (cur < 4) {
    j = j + 1 > window.sliderHelpLength - 1 ? 0 : j + 1;
    genHtmlHelpToYou(helptoyou["slider_" + j], classIndex);
    classIndex--;
    cur++;
  }
  setTimeout(() => {
    for (let index = 0; index <= window.sliderHelpLength; index++) {
      $(`.section.section-landing .row-eq-height .item-slider`).removeClass(`ready-to-show-${index}`);
    }
  }, 100);
  initTrackHelpToYou(true);
}

function genHtmlHelpToYou(item, indexCurrent) {
  var className = {
    class_4: "item-slider slider_0 slider_1 slider_2 slider_3 slider_4",
    class_3: "item-slider slider_0 slider_1 slider_2 slider_3",
    class_2: "item-slider slider_0 slider_1 slider_2",
    class_1: "item-slider slider_0 slider_1",
    class_0: "item-slider slider_0",
  }
  var htmlResult = ""
  htmlResult +=
    `
      <div class="${className["class_" + indexCurrent]} ${"ready-to-show-" + indexCurrent}" id="${"slider_" + indexCurrent}">
        <div class="icon">
          <img alt="market" src="${require("../../assets/images/" + item.icon)}" />
        </div>
        <div class="content">
          <div class="title">${item.title}</div>
          <div class="description">${item.content}</div>
      </div>
    `
  $(`.section.section-landing .row-eq-height`).append(htmlResult);
}